import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Folder } from 'assets/svg/icon-folder.svg'

function IconFolder(props: IconProps): JSX.Element {
  const title = 'icon-folder'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Folder {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconFolder
